import { Pipe, PipeTransform } from '@angular/core'
import { COLOR, patientAccountClearanceStatusColorMap } from '@mmx/shared'

@Pipe({
  name: 'accountClearanceStatusToColor',
  pure: true,
})
export class AccountClearanceStatusToColorPipe implements PipeTransform {
  public transform(statusCode?: string): COLOR {
    return patientAccountClearanceStatusColorMap[statusCode] ?? COLOR.DEFAULT
  }
}
